import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PrivacyPolicy from './pages/PrivacyPolicy';

const VoPubRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/privacy" element={<PrivacyPolicy />} />
    </Routes>
  );
};

export default VoPubRoutes;